import { makeStyles } from "@fluentui/react-components";
import React from "react";
import StatusBar from "../statusBar";
import ToastElement from "../../../modules/toast";

const useHeaderStyles = makeStyles({
  root: {
    position: "sticky",
    top: "0",
    left: "0",
    width: "100%",
    zIndex: 1000,
  },
});

const Header = () => {
  const styles = useHeaderStyles();

  return (
    <div className={styles.root}>
      <StatusBar />
      <ToastElement />
    </div>
  );
};

export default Header;
